import { Component, OnInit } from '@angular/core';
import { OrganizationService } from '../_services/organization.service';

import { Organization } from '../_models/organization';

@Component({
  moduleId: module.id,
  templateUrl: 'orgs.component.html',
  styleUrls: ['orgs.component.css']
})

export class OrgsComponent implements OnInit {
  organizations: Array<Organization>;

  constructor(
    private organizationService: OrganizationService
  ){}

  ngOnInit() {
    this.organizationService.getAll()
      .then((orgs) => {
        this.organizations = orgs;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/orgs/orgs.component.ts